import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-screen-2xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热门话题</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            全网观众正在热议的影视话题，加入讨论分享你的看法
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topicItems.map((item, index) => (
            <div
              key={item.id}
              className="group flex items-center gap-3 px-5 py-3 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
              style={{ animation: `fadeInUp 0.4s ease-out ${index * 0.06}s both` }}
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">
                #{item.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}